"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ModuleDate = _interopRequireDefault(require("./ModuleDate"));

var _reactI18next = require("react-i18next");

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  byline: {
    //        display: "flex",
    //        alignItems: "baseline",
    fontFamily: "Akkurat, sans-serif",
    fontSize: "14px",
    color: theme.palette.text.secondary
  },
  author: {
    display: "inline",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "normal"
  },
  datetime: {
    display: "inline",
    fontStyle: "normal",
    fontWeight: "normal"
  }
}));

const ModuleByline = ({
  author,
  datetime,
  locale = "nb",
  format = "relative"
}) => {
  const classes = useStyles();

  if (!datetime) {
    return false;
  }

  return _react.default.createElement(_Typography.default, {
    className: classes.byline,
    noWrap: true,
    component: "h3"
  }, _react.default.createElement(_ModuleDate.default, {
    datetime: datetime,
    locale: locale,
    format: format,
    className: classes.datetime
  }), ' ', _react.default.createElement("b", {
    className: classes.author
  }, "by ", author));
};

ModuleByline.propTypes = process.env.NODE_ENV !== "production" ? {
  author: _propTypes.default.string,
  datetime: _propTypes.default.string,
  locale: _propTypes.default.string,
  format: _propTypes.default.string
} : {};
var _default = ModuleByline;
exports.default = _default;
module.exports = exports.default;